import React from 'react';
import './App.css';
import { Switch, Route, useHistory } from "react-router-dom";
//import SrNoValidation from "./components/assessment/SRNoValidation";
import TestInstructions from "./components/assessment/TestInstructions";

import TestWithQuestion from './components/testWithQuestion/TestWithQuestion';
import DetailedReport from './components/assessment/DetailedReport';
import SRNoValidationContainer from './containers/assessment/SRNoValidationContainer';
import { Provider } from 'react-redux';
import createStore from './createStore';
import { PersistGate } from 'redux-persist/integration/react';
import AssessmentSummary from './components/assessment/AssessmentSummary';
import YouTubePlayer from './components/YouTube/youtubePlayer';

const { store, persistor } = createStore()

function App() {
    return (
        // <Router history={history}>
        <Provider store={store} >
            <PersistGate loading={null} persistor={persistor} >
                <div>
                    <Switch >
                        <Route exact path="/"
                            component={SRNoValidationContainer}
                        /> <Route path="/instructions" component={TestInstructions}
                        />
                        <Route path="/test" component={TestWithQuestion} />
                        <Route path="/detailedReport" component={DetailedReport} />
                        <Route path="/assessmentSummary" component={AssessmentSummary} />
                        <Route path="/youTubeScreen" component={YouTubePlayer} />

                    </Switch>
                </div>
                { /* // </Router> */} {
                    /* // <div className="App">
                        //     <Routes />
                        // </div> */
                }
            </PersistGate>
        </Provider >
    );
}

export default App;
